import { useState, useEffect } from "react";
import { getAccountJournalAsync } from "./../../../../services/journalService";
import { getCurrencyAmount } from "../../../../utils/stringUtils";
import moment from "moment";
import _ from "lodash";

const Journal = ({ id }) => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    { path: "created_on", label: "Date" },
    { path: "transaction_number", label: "Transaction No." },
    { path: "code", label: "Code" },
    { path: "debit", label: "Debit" },
    { path: "credit", label: "Credit" },
  ];

  useEffect(() => {
    let mounted = true;
    let total_debit = 0;
    let total_credit = 0;

    const fetchJournal = async () => {
      setIsLoading(true);

      const response = await getAccountJournalAsync(id);
      const { result } = response;

      const data = result.map((item) => {
        total_debit += item.debit;
        total_credit += item.credit;

        item["created_on"] = moment(item.created_on).format("LLL");
        item["credit"] = (
          <div className="text-right">
            <span>&#8369; {getCurrencyAmount(item.credit)}</span>
          </div>
        );
        item["debit"] = (
          <div className="text-right">
            <span>&#8369; {getCurrencyAmount(item.debit * -1)}</span>
          </div>
        );

        return item;
      });

      if (mounted) {
        setData(data);
        setIsLoading(false);
        setTotal(total_debit + total_credit);
      }
    };

    fetchJournal();

    return () => {
      mounted = false;
    };
  }, [id]);

  const renderCell = (item, column) => {
    if (column.content) return column.content(item);

    return _.get(item, column.path);
  };

  const createKey = (item, column) => {
    return item.id + (column.path || column.key);
  };

  return (
    <div className="card p-8">
      <div className="overflow-auto lg:overflow-visible">
        <table className="min-w-full max-h-96 mb-5">
          <thead className="bg-gray-100">
            <tr>
              {columns.map((column) => (
                <th
                  key={column.path}
                  className="py-3 px-6 text-sm font-normal first:rounded-l-lg last:rounded-r-lg text-gray-400"
                >
                  <div className="flex justify-between items-center">
                    {column.label}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isLoading && (
              <tr className="bg-gray-50">
                <td
                  className="p-4 px-6 whitespace-nowrap text-gray-400 text-sm text-center"
                  colSpan={columns.length}
                >
                  Loading...
                </td>
              </tr>
            )}
            {!isLoading && data.length === 0 && (
              <tr className="bg-gray-50">
                <td
                  className="p-4 px-6 whitespace-nowrap text-gray-400 text-sm text-center"
                  colSpan={columns.length}
                >
                  No data available
                </td>
              </tr>
            )}
            {!isLoading &&
              data.length > 0 &&
              data.map((item, key) => (
                <tr key={key} className="hover:bg-gray50">
                  {columns.map((column) => (
                    <td
                      key={createKey(item, column)}
                      className="p-4 px-6 whitespace-nowrap text-gray-400 text-sm text-left"
                    >
                      {renderCell(item, column)}
                    </td>
                  ))}
                </tr>
              ))}
            <tr>
              <td colSpan="4" className="text-right">
                <div className="text-gray-600 text-sm">Remaining Balance</div>
              </td>
              <td className="text-right px-6 py-5">
                <div className="text-gray-600 text-sm">
                  &#8369; {getCurrencyAmount(total)}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Journal;
